import { AxiosInstance } from 'axios';

import * as common from '../../../../../../typings/api/skymap/rest/v0/.common';
import * as types from '../../../../../../typings/api/skymap/rest/v0/timeline-containers';

export class TimelineServiceV0 implements types.Handlers {
  private serviceEndpoint = '/timelinecontainers';

  constructor(private axios: AxiosInstance) {}
  updateTimelineContainer(
    params: types.UpdateTimelineContainerParameters,
  ): Promise<types.UpdateTimelineContainerResponse> {
    throw new Error('Method not implemented.');
  }
  deleteTimelineContainer(
    params: types.DeleteTimelineContainerParameters,
  ): Promise<common.MessageOnlyResponse> {
    throw new Error('Method not implemented.');
  }
  setScanTimelineContainer(
    params: types.SetScanTimelineContainerParameters,
  ): Promise<types.UpdateTimelineContainerResponse> {
    throw new Error('Method not implemented.');
  }
  async setTiledModelTimelineContainer({
    path,
    body,
  }: types.SetTiledModelTimelineContainerParameters): Promise<types.UpdateTimelineContainerResponse> {
    return (await this.axios.put(`${this.serviceEndpoint}/${path.containerId}/tiled-models`, body))
      .data;
  }
  setOrthotileTimelineContainer(
    params: types.SetOrthotileTimelineContainerParameters,
  ): Promise<types.UpdateTimelineContainerResponse> {
    throw new Error('Method not implemented.');
  }
  updateAssociatedPointCloud(
    params: types.UpdateAssociatedPointCloudParameters,
  ): Promise<types.UpdateTimelineContainerResponse> {
    throw new Error('Method not implemented.');
  }
}
